$(document).ready(function () {
    
    $('.slider-arrows .arrow').click(function(){
        var elem    = $(this),
            dir     = elem.data('dir'),
            parent  = elem.parent(),
            wrapper = parent.data('wrapper'),
            slider  = parent.data('slider'),
            wrapper = elem.parents('.' + wrapper),
            slider  = wrapper.find('.' + slider);        

        slider.slick('slick' + dir);
    })

});